function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
import every from 'lodash/every';
import omit from 'lodash/omit';
import isEmpty from 'lodash/isEmpty';
import isNumber from 'lodash/isNumber';
import isNaN from 'lodash/isNaN';
import { mapState, mapGetters, mapMutations } from 'vuex';
export default {
  props: {
    side: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  computed: _objectSpread({}, mapState({
    elements: function elements(s) {
      return s.elements;
    }
  }), {}, mapGetters({
    resultType: 'api/formResultType'
  }), {
    position: function position() {
      return {
        side: this.side,
        index: this.index
      };
    },
    fields: function fields() {
      return this.$store.getters['elements/at'](this.side, this.index);
    },
    unit: {
      get: function get() {
        return this.fields.unit.value;
      },
      set: function set(value) {
        this.setFieldValue(_objectSpread({}, this.position, {
          field: 'unit',
          value: value
        }));
      }
    },
    disabled: function disabled() {
      var _this = this;

      return every(omit(this.fields, 'unit'), function (f) {
        return _this.isBlank(f.value);
      });
    }
  }),
  methods: _objectSpread({}, mapMutations('elements', ['setFieldValue']), {
    isBlank: function isBlank(value) {
      // See: https://stackoverflow.com/a/36693986/5828035
      return isEmpty(value) && !isNumber(value) || isNaN(value);
    }
  }),
  watch: {
    disabled: function disabled(value) {
      if (value) {
        this.setFieldValue(_objectSpread({}, this.position, {
          field: 'unit',
          value: null
        })); // Reset unit field when is disabled
      }
    }
  }
};